import { ArrowRightIcon } from "lucide-react";

import type { DiffItem } from "../VersionDiffViewer";
import { DiffItemRow } from "../VersionDiffViewer";
import { isProviderReviewItem } from "../utils/review-items";

import LoadingSpinner from "@/components/LoadingSpinner";

interface DiffContentProps {
  isLoading: boolean;
  diffItems: DiffItem[];
}

export const DiffContent = ({ isLoading, diffItems }: DiffContentProps) => {
  const providerDiffItems = diffItems.filter(isProviderReviewItem);
  const fileDiffItems = diffItems.filter(item => !isProviderReviewItem(item));

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <LoadingSpinner />
        <span className="ml-3 text-sm text-gray-500">Loading versions...</span>
      </div>
    );
  }

  if (diffItems.length === 0) {
    return (
      <div className="flex items-center justify-center py-12 text-sm text-gray-500">
        No differences found between these versions.
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-full space-y-2">
      {providerDiffItems.map(item => (
        <div
          key={item.key}
          className="flex items-center gap-2 rounded-md border border-gray-200 bg-gray-50 px-4 py-3 text-sm text-gray-700"
        >
          <span className="font-medium">Provider:</span>
          <span>{item.originalContent ?? "Universal"}</span>
          <ArrowRightIcon className="size-4 shrink-0 text-gray-400" />
          <span>{item.currentContent ?? "Universal"}</span>
        </div>
      ))}
      {fileDiffItems.map(item => (
        <DiffItemRow key={item.key} item={item} />
      ))}
    </div>
  );
};
